import {
    timeSeriesPeriodTranslateFilter,
    TimeSeriesPeriodTranslateFilter
} from "./TimeSeriesPeriodTranslate";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.pipes`;

    return angular.module(moduleName, [])
                  .filter(TimeSeriesPeriodTranslateFilter, timeSeriesPeriodTranslateFilter)
                  .name;
}
